import React, { useEffect, useState } from "react";
import MusicIcon from "assets/images/musicIcon.png";
import "./index.scss";
import SyncLyrics from "./syncLyrics";
import useInputKeys from "hooks/useInputKeys";
// import { duration } from "@mui/material";
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import {useGetTimelineLyrics} from "hooks/timeline";

const Lyrics = ({
  currentFrequency,
  ownersTitle,
  setLyrics,
  timelinesData,
  currentTimelineIndex,
}) => {
  const {currentTimeMusic,currentTimeline, setExpand, expand} = useInputKeys();
  const {mutate: fetchLyrics, data: fetchLyricsResponse}= useGetTimelineLyrics();
  const [musicLyrics, setMusicLyrics] = useState([]);

  const [musicName, setMusicName] = useState("");

  useEffect(() => {
    if (
      timelinesData.length > 0 &&
      currentTimelineIndex < timelinesData.length
    ) {
      const currentData = timelinesData[currentTimelineIndex];
      setMusicName(currentData.text);
    }
  }, [currentTimelineIndex, timelinesData]);

  useEffect(()=>{
    if(currentTimeline?.timelineId){
      fetchLyrics({timelineId: currentTimeline?.timelineId});
    }
  },[fetchLyrics, currentTimeline?.timelineId])

  useEffect(()=>{
    if(fetchLyricsResponse){
      console.log(fetchLyricsResponse)
      setMusicLyrics(fetchLyricsResponse.lyrics);
    }
  },[fetchLyricsResponse, setLyrics])

  return (
    <div className={`lyricsContainer ${expand ? "expand" : ""}`} >
      <div className="top-lyrics">
        <div className="frequency">{`FQ: ${currentFrequency || "-"}`}</div>
        <div className="title-lyrics">
          <div className="artist-name">{ownersTitle[currentFrequency]}</div>
          <div className="music-name">{musicName}</div>
        </div>
        <div
          className="musicIcon"
          onClick={() => {
            setLyrics("");
            setExpand(false)
          }}
        >
          <img src={MusicIcon} alt="Music Icon" />
        </div>
      </div>
      <div className="lyrics">
        <SyncLyrics currentTimeAudio={currentTimeMusic} data={musicLyrics} />
      </div>
      <div className={`${expand? 'expand-icon' : 'not-expand-icon'}`} onClick={() => {setExpand(!expand)}}><UnfoldMoreIcon/></div>
    </div>
  );
};

export default Lyrics;
